var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1